/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { AppLayout } from '@veeam/components';
import { Outlet } from 'react-router-dom';

import { BaseLayout } from '../BaseLayout';
import { useGlobalAppData } from '../../providers/GlobalContextProvider';

export interface EmptyLayoutProps {
    currentPath: string;
    children?: React.ReactElement;
}

export const EmptyLayout: React.FC<EmptyLayoutProps> = ({ currentPath, children }) => {
    const { appMinWidth } = useGlobalAppData();

    return (
        <BaseLayout>
            <AppLayout
                minWidth={appMinWidth}
                body={children ?? <Outlet key={currentPath} />}
            />
        </BaseLayout>
    );
};
